import { Component, forwardRef, Input } from '@angular/core';

import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { WireSocialLinkModel } from '../../models/wire-social-link.model';
import { SocialLinkFieldModel } from '../../models/social-link-field.model';
import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { wireLinkTypesToLabelStrings, WireSocialLinkEnum } from '../../enums/wire-social-link.enum';


/**
 * This component is the Newswire version of {@link LinksListFieldComponent}
 */
@Component({
    selector: 'agpr-social-link-field',
    templateUrl: './social-link-field.component.html',
    styleUrls: ['./social-link-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => SocialLinkFieldComponent)
        }
    ],
    standalone: false
})
export class SocialLinkFieldComponent extends AbstractFormFieldComponent {
    readonly linkTypes = WireSocialLinkEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly linkLimit = 10;
    readonly wireLinkTypesToLabelStrings = wireLinkTypesToLabelStrings;
    readonly linkTypesOptions = [
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.TWITTER], WireSocialLinkEnum.TWITTER),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.FACEBOOK], WireSocialLinkEnum.FACEBOOK),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.INSTAGRAM], WireSocialLinkEnum.INSTAGRAM),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.YOUTUBE], WireSocialLinkEnum.YOUTUBE),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.LINKEDIN], WireSocialLinkEnum.LINKEDIN),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.SNAPCHAT], WireSocialLinkEnum.SNAPCHAT),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.TIKTOK], WireSocialLinkEnum.TIKTOK),
        new DropdownOptionModel(wireLinkTypesToLabelStrings[WireSocialLinkEnum.WEBSITE], WireSocialLinkEnum.WEBSITE)
    ];

    @Input() declare field: SocialLinkFieldModel;
    @Input() declare value: WireSocialLinkModel[];

    constructor() {
        super();
    }

    addLink() {
        this.value.push(this.newWireLinkModel());
        this.valueChange();
    }

    valueChange(link?: WireSocialLinkModel) {
        if (link) {
            this.validateLink(link);
        }

        this.changes.emit(this.value);
    }

    onLinkAction(action: 'moveUp' | 'moveDown' | 'delete', index: number) {
        switch (action) {
            case 'moveUp':
                this.value.splice(index - 1, 0, this.value.splice(index, 1)[0]);
                break;
            case 'moveDown':
                this.value.splice(index + 1, 0, this.value.splice(index, 1)[0]);
                break;
            case 'delete':
                this.value.splice(index, 1);
                break;
        }
        this.valueChange();
    }

    private newWireLinkModel(): WireSocialLinkModel {
        return new WireSocialLinkModel({
            linkType: WireSocialLinkEnum.TWITTER,
            url: '',
            text: ''
        } as WireSocialLinkModel);
    }

    private validateLink(link: WireSocialLinkModel) {
        link.isUrlValid();
    }
}
